export const subscriptionConstants = {

	/*
	 * Plan that can be subscribed to
	 *
	 * Note: The values are ultimately being transformed using i18n
	 */
	PLANS: {
		FREE: {
			NAME: 'FREE PLAN',
			UUID: '4602653d-0846-4a6b-87ac-804c4acbf11e',
			DESC: '30 day trial | No credit card necessary',
			PLAN_RATE: '$0 per month',
			TRIAL: '30 day trial',
			GIST_ALLOWANCE: '10 hrs of video',
			STORAGE_ALLOWANCE: '15 GB of storage',
			GIST_RECURRENCE: '',
			GIST_RATE: '',
		},
		BASIC: {
			NAME: 'BASIC PLAN',
			UUID: '2e46b12a-4aa7-4248-a76c-44fa30b5836a',
			DESC: 'Basic Plan | $5 per month',
			PLAN_RATE: '$5 per month',
			TRIAL: 'First 30 days free',
			GIST_ALLOWANCE: '10 hrs of video',
			STORAGE_ALLOWANCE: '25 GB of storage',
			GIST_RECURRENCE: '',
			GIST_RATE: '$3 / hr for additional processing',
		},
		STANDARD: {
			NAME: 'STANDARD PLAN',
			UUID: 'dcdcd60e-1042-46cc-b22c-9c2da6ce5140',
			DESC: 'Standard Plan | $15 per month',
			PLAN_RATE: '$15 per month',
			TRIAL: 'First 30 days free',
			GIST_ALLOWANCE: '10 hrs of video',
			STORAGE_ALLOWANCE: '100 GB of storage',
			GIST_RECURRENCE: '5 hrs / month included',
			GIST_RATE: '$2.5 / hr per additional processing',
		},
		PROFESSIONAL: {
			NAME: 'PROFESSIONAL PLAN',
			UUID: 'f2c220ac-16a7-49dd-835e-ded82498afd2',
			DESC: 'Professional Plan | $35 per month',
			PLAN_RATE: '$35 per month',
			TRIAL: 'First 30 days free',
			GIST_ALLOWANCE: '10 hrs of video',
			STORAGE_ALLOWANCE: '250 GB of storage',
			GIST_RECURRENCE: '15 hrs / month included',
			GIST_RATE: '$1.5 / hr per additional processing',
		},
	},
	
	/*
	 * List of main plan uuid(s)
	 */
	PLAN_UUID_LIST: [
		'4602653d-0846-4a6b-87ac-804c4acbf11e',     // free
		'2e46b12a-4aa7-4248-a76c-44fa30b5836a',     // basic
		'dcdcd60e-1042-46cc-b22c-9c2da6ce5140',     // standard
		'f2c220ac-16a7-49dd-835e-ded82498afd2',     // professional
	],

	/*
     * Subscription Constant :
     */
	SUBSCRIPTION_GRACE_PERIOD: 'PAYMENT_PENDING',
};